const state = {
  configurationFilters: {},
  achievmentClubbingData: {},
  proDataSetupData: {},
  branchDropdownOptions:[],
  jobLists: [],
  groupTypeLists: [],
};

export default state;
